module.exports = require("./../../_gen/starling/errors/NotSupportedError");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/errors/NotSupportedError.js
// module id = 178
// module chunks = 0